import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../Firebase Functions/firebase";
import { doc, setDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import UploadVendorRequestToQuickBase from "../Quickbase Functions/UploadVendorRequestToQuickbase";
import "../TruckServices/ChecklistForm.css";

const VendorPaymentRequestForm = () => {
  const location = useLocation();
  const incidentId = location.state?.incidentId;
  const navigate = useNavigate();

  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [vendorImages, setVendorImages] = useState([]);
  const [formData, setFormData] = useState({
    vendorName: "",
    vendorContact: "",
    orderReference: "",
    jobOrEmployeeForm: "",
    amount: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files).slice(0, 3);
    setVendorImages(files);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.vendorName.trim()) newErrors.vendorName = "Vendor Name is required.";
    if (!formData.vendorContact.trim()) newErrors.vendorContact = "Vendor Contact is required.";
    if (!formData.orderReference.trim()) newErrors.orderReference = "Order/Quote Number is required.";
    if (!formData.jobOrEmployeeForm.trim()) newErrors.jobOrEmployeeForm = "Job/Employee Form is required.";
    if (!formData.amount.trim()) newErrors.amount = "Amount is required.";

    if (Object.keys(newErrors).length > 0) {
      console.warn("❌ Form validation errors:", newErrors);
      setErrors(newErrors);
      return false;
    }

    return true;
  };

   const handleSubmit = async (e) => {
    e.preventDefault();

    if (!incidentId) {
      setModalMessage("Missing incident ID. Please save the incident report first.");
      setShowModal(true);
      return;
    }

    if (!validateForm()) return;

    try {
      const storage = getStorage();
      const uploadedImageURLs = [];

      for (const file of vendorImages) {
        const fileRef = ref(storage, `vendorRequestImages/${incidentId}/image-${Date.now()}-${file.name}`);
        await uploadBytes(fileRef, file);
        const downloadURL = await getDownloadURL(fileRef);
        uploadedImageURLs.push(downloadURL);
      }

      await setDoc(doc(db, "vendorRequestForm", incidentId), {
        ...formData,
        incidentId,
        vendorImageURLs: uploadedImageURLs,
        createdAt: serverTimestamp(),
      });

      await updateDoc(doc(db, "incidentReports", incidentId), {
        vendorRequestCompleted: true,
      });

      await UploadVendorRequestToQuickBase(incidentId);

      setModalMessage("✅ Vendor Payment Request saved and uploaded to QuickBase.");
    } catch (error) {
      console.error("❌ Error during vendor request submission:", error);
      setModalMessage("❌ Failed to save or upload. Please try again.");
    } finally {
      setShowModal(true);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="checklist-form" noValidate>
      <h2 className="form-title">Vendor Payment Request</h2>

      {[
        { label: "Vendor Name", field: "vendorName" },
        { label: "Vendor Contact Information", field: "vendorContact" },
        { label: "Order / Quote / Invoice Number", field: "orderReference" },
        { label: "Job Name or # / Employee Deduction Form", field: "jobOrEmployeeForm" },
        { label: "Amount", field: "amount" },
      ].map(({ label, field }) => (
        <div className="form-group" key={field}>
          <label>{label}</label>
          <input
            type="text"
            value={formData[field]}
            onChange={(e) => handleChange(field, e.target.value)}
            className="form-control"
          />
          {errors[field] && (
            <p style={{ color: "red", fontSize: "0.85rem", marginTop: "4px" }}>{errors[field]}</p>
          )}
        </div>
      ))}

       <div className="form-group">
        <label>Upload Up to 3 Images</label>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageChange}
          className="form-control"
        />
        <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
          {vendorImages.map((file, index) => (
            <img
              key={index}
              src={URL.createObjectURL(file)}
              alt={`Preview ${index + 1}`}
              style={{ width: 100, height: "auto", border: "1px solid #ccc", borderRadius: "4px" }}
            />
          ))}
        </div>
      </div>

      <button type="submit" className="secondary-button" style={{ marginTop: "1.5rem" }}>
        Save Vendor Payment Request
      </button>

      {showModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <h2>Notice</h2>
            <p>{modalMessage}</p>
            <button
              className="modal-close-button"
              onClick={() => {
                setShowModal(false);
                if (modalMessage.includes("✅")) {
                  navigate("/saved-incident-reports");
                }
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </form>
  );
};

export default VendorPaymentRequestForm;
